const CONFIG = {
  STRIPE_KEY:
    "pk_test_51OEZFSBZGWXP17wPSXSfVjlhfo0kwBKXE1m1ZQqcmT5Syx9ouSEdOv3SJ83fwBKsAARGsPWrJGQFuLJtWNAybdqx002Mzpp7iX",
  CLIENT_ID:
    "Aet8G1KieknovTM-30vr9t4sHWZY_b7w_B4j1ALmvpUDT1hjbL9S0_7bqis22vBcgWRb_j-jCK1T99Su",
};

export default CONFIG;
